export default path => () => import(`../../views/judge${path}.vue`);



// WEBPACK FOOTER //
// ./src/router/judge/view.js